// import screen1 from 'app/assets/sidebar/choose_your_focus.png'
// import screen1Selected from 'app/assets/sidebar/choose_your_focus_selected.png'
// import screen2 from 'app/assets/sidebar/earnings.png'
// import screen2Selected from 'app/assets/sidebar/earnings_selected.png'
// import screen3 from 'app/assets/sidebar/environment_crime.png'
// import screen3Selected from 'app/assets/sidebar/environment_crime_selected.png'
// import screen4 from 'app/assets/sidebar/educational_attainment.png'
// import screen4Selected from 'app/assets/sidebar/educational_attainment_selected.png'
// import screen5 from 'app/assets/sidebar/tb6_college_going.png'
// import screen5Selected from 'app/assets/sidebar/tb6_select.png'
// import screen6 from 'app/assets/sidebar/HSgraduation_college_going.png'
// import screen6Selected from 'app/assets/sidebar/HSgraduation_college_going_selected.png'
// import screen7 from 'app/assets/sidebar/tb7_interventions.png'
// import screen7Selected from 'app/assets/sidebar/tb7_select.png'

import screen1 from "app/assets/sidebar/stateoverview.svg";
import screen1Selected from "app/assets/sidebar/stateoverview.svg";
import screen2 from "app/assets/sidebar/jobsandpro.svg";
import screen2Selected from "app/assets/sidebar/jobsandpro.svg";
import screen3 from "app/assets/sidebar/Industryanalysis.png";
import screen3Selected from "app/assets/sidebar/Industryanalysis.png";
import screen4 from "app/assets/sidebar/degreeandcert.svg";
import screen4Selected from "app/assets/sidebar/degreeandcert.svg";
import screen5 from "app/assets/sidebar/occupation_detail.svg";
import screen5Selected from "app/assets/sidebar/occupation_detail.svg";
import screen6 from "app/assets/sidebar/education_s6.svg";
import screen6Selected from "app/assets/sidebar/education_s6.svg";
import screen7 from "app/assets/sidebar/pathways.png";
import screen7Selected from "app/assets/sidebar/pathways.png";

export const ScreenTitles = [
  {
    title: "Overview",
    icon: screen1,
    selectedIcon: screen1Selected,
  },
  {
    title: "Industry Overview",
    icon: screen2,
    selectedIcon: screen2Selected,
  },
  {
    title: "Industry Detail",
    icon: screen3,
    selectedIcon: screen3Selected,
  },
  {
    title: "Occupation Overview",
    icon: screen4,
    selectedIcon: screen4Selected,
  },
  {
    title: "Occupation Detail",
    icon: screen5,
    selectedIcon: screen5Selected,
  },
  {
    title: "Pathways",
    icon: screen7,
    selectedIcon: screen7Selected,
  },
  {
    title: "Education",
    icon: screen6,
    selectedIcon: screen6Selected,
  },
];
